import GetWebsitesUrls from '@/graphql/GetWebsitesUrls.gql'
import { createProvider } from '@/vue-apollo'

const apollo = createProvider()

export default {
  async getWebsiteUrls ({ commit, dispatch }) {
    try {
      const { data } = await apollo.defaultClient.query({
        query: GetWebsitesUrls,
        fetchPolicy: 'no-cache'
      })
      return data.getWebsitesUrls
    } catch (error) {
      dispatch('showError', error)
    }
  }
}
